// extracted by mini-css-extract-plugin
module.exports = {"container":"Download_container__qW0WU","text":"Download_text__ohPpi","qrCode":"Download_qrCode__cMhCl","logos":"Download_logos__wiQ_i","logo":"Download_logo__0J4VG"};